import { ReactElement } from 'react';
import { Button } from '../shared/button/Button';
import styles from './RemovedCartItem.module.scss';
import { Loading } from '../shared/loading/Loading';

type Props = {
    title: string;
    onClick: () => void;
};

export function RemovedCartItem({
  title,
  onClick,
}: Props): ReactElement {
  return (
    <div className={styles.removed_cart_item_container}>
      <Loading className={styles.removed_cart_item_skeleton} />
      <div className={styles.removed_cart_item_title_container}>
        <span className={styles.removed_cart_item_title}>{title}</span>
        <span className={styles.removed_cart_item_text}>Removed from Cart</span>
      </div>
      <div className={styles.removed_cart_item_button}>
        <Button
          text="Undo"
          onClick={onClick}
          isEnabled
          isSecondary
        />
      </div>
    </div>
  );
}
